<template>
    <div :class="layout == 'PPJB' ? 'pb-5' : ''" id="cardContainer">
        <v-card id="cardsForHeight" :outlined="styles.outlined" :elevation="styles.elevation" :height="cardHeight"   :class="styles.card" :style="styles.custom">
            <v-row :class="layout == 'GME' ? '' : 'align-center'">
                <!-- image on left  -->
                <template v-if="styles.imagePosition == 'left'">
                    <template v-if="layout == 'BESD2'">
                        <v-col :class="$vuetify.breakpoint.xsOnly ? 'ml-3' : 'ml-5'">
                            <div :style="$vuetify.breakpoint.xsOnly ? 'width: 150px' : 'width: 250px'">
                                <v-text-field v-if="pageType == 'Canvas'" label="Image URL or Link" dense outlined v-model="item.image"></v-text-field>
                                <v-img v-if="item.image != null  " :src="item.image" height="150" ></v-img>

                            </div>
                        </v-col>
                        <v-col>
                            <div :class="styles.text"
                                @focusout="onEditableChange('text')"
                                :contenteditable="editableContent"
                                @paste="filterPastedContent"
                                :id="`${indexes.element}-${indexes.column}-${indexes.data}-imgcard-text`"
                                v-html='item.text.replace(/font-size: [^;]+;/g, "")'
                            >

                            </div>
                            <v-card color="#06D6A0" class="corner-div" elevation="0">
                            </v-card>
                        </v-col>
                    </template>
                    <template v-else>
                        <v-col :cols="styles.settings.colsImage" :class="imageLeftColClass()" >
                            <v-text-field v-if="pageType == 'Canvas'" label="Image URL or Link" dense outlined v-model="item.image"></v-text-field>
                            <v-img v-if="item.image != null" contain
                                :height="styles.image.height"
                                :width="styles.image.width"
                                :src="item.image"
                                class="mx-auto"
                            >
                            </v-img>
                        </v-col>
                        <v-col :cols="styles.settings.colsText" v-if="item.text.length != 0">
                            <p :class="styles.text"
                                @focusout="onEditableChange('text')"
                                :contenteditable="editableContent"
                                @paste="filterPastedContent"
                                :id="`${indexes.element}-${indexes.column}-${indexes.data}-imgcard-text`"
                                v-html='item.text.replace(/font-size: [^;]+;/g, "")'
                            ></p>
                            <div v-if="styles.subtitle" :class="styles.subtitle"
                                @focusout="onEditableChange('subtitle')"
                                :contenteditable="editableContent"
                                @paste="filterPastedContent"
                                :id="`${indexes.element}-${indexes.column}-${indexes.data}-imgcard-subtitle`"
                                v-html='item.subtitle.replace(/font-size: [^;]+;/g, "")'
                            ></div>
                        </v-col>
                    </template>
                </template>

                <!-- image on right  -->
                <template v-if="styles.imagePosition == 'right'">
                    <v-col :cols="styles.settings.colsText">
                        <p :class="styles.text"
                            @focusout="onEditableChange('text')"
                            :contenteditable="editableContent"
                            @paste="filterPastedContent"
                            :id="`${indexes.element}-${indexes.column}-${indexes.data}-imgcard-text`"
                            v-html='item.text.replace(/font-size: [^;]+;/g, "")'
                        ></p>
                        <div v-if="styles.subtitle" :class="styles.subtitle"
                            @focusout="onEditableChange('subtitle')"
                            :contenteditable="editableContent"
                            @paste="filterPastedContent"
                            :id="`${indexes.element}-${indexes.column}-${indexes.data}-imgcard-subtitle`"
                            v-html='item.subtitle.replace(/font-size: [^;]+;/g, "")'
                        ></div>
                    </v-col>
                    <v-col :cols="styles.settings.colsImage">
                        <v-text-field v-if="pageType == 'Canvas'" label="Image URL or Link" dense outlined v-model="item.image"></v-text-field>
                        <v-img v-if="item.image != null && pageType == 'Canvas'" contain
                            :height="styles.image.height"
                            :width="styles.image.width"
                            :src="item.image"
                        ></v-img>
                    </v-col>
                </template>

                <!-- image on top  -->
                <template v-if="styles.imagePosition == 'top'">
                    <v-col>
                        <v-card v-if="styles.doubleCard.status" :class="styles.doubleCard.inner">
                            <v-text-field v-if="pageType == 'Canvas'" label="Image URL or Link" dense outlined v-model="item.image"></v-text-field>
                            <div class="mx-5 my-5 text-center" >
                                <v-img v-if="item.image != null" contain
                                    :height="styles.image.height"
                                    :width="styles.image.width"
                                    :src="item.image"
                                >
                                </v-img>
                            </div>
                        </v-card>
                        <div v-else-if="!styles.doubleCard.status">
                            <v-text-field v-if="pageType == 'Canvas'" label="Image URL or Link" dense outlined v-model="item.image"></v-text-field>
                            <v-img v-if="item.image != null" :contain="containImage"
                                :height="styles.image.height"
                                :width="styles.image.width"
                                :src="item.image"
                                :class="styles.class"
                                class="mx-auto"
                            >
                            </v-img>
                        </div>
                        <div>
                            <p  :class="styles.text"
                                @focusout="onEditableChange('text')"
                                :contenteditable="editableContent"
                                @paste="filterPastedContent"
                                :id="`${indexes.element}-${indexes.column}-${indexes.data}-imgcard-text`"
                                v-html="item.text"
                            ></p>
                            <div v-if="styles.subtitle" :class="styles.subtitle"
                                @focusout="onEditableChange('subtitle')"
                                :contenteditable="editableContent"
                                @paste="filterPastedContent"
                                :id="`${indexes.element}-${indexes.column}-${indexes.data}-imgcard-subtitle`"
                                v-html='item.subtitle.replace(/font-size: [^;]+;/g, "")'
                            ></div>
                        </div>
                    </v-col>
                </template>

                <!-- image on bottom  -->
                <template v-if="styles.imagePosition == 'bottom'">
                    <v-col>
                        <div>
                            <p :class="styles.text"
                                @focusout="onEditableChange('text')"
                                :contenteditable="editableContent"
                                @paste="filterPastedContent"
                                v-html='item.text.replace(/font-size: [^;]+;/g, "")'
                                :id="`${indexes.element}-${indexes.column}-${indexes.data}-imgcard-text`"
                            ></p>
                            <div v-if="styles.subtitle" :class="styles.subtitle"
                                @focusout="onEditableChange('subtitle')"
                                :contenteditable="editableContent"
                                @paste="filterPastedContent"
                                :id="`${indexes.element}-${indexes.column}-${indexes.data}-imgcard-subtitle`"
                                v-html='item.subtitle.replace(/font-size: [^;]+;/g, "")'
                            ></div>
                        </div>

                        <div v-if="item.image != null" class="my-5 text-center" :class="layout == 'TE' ? '' : 'mx-5'">
                            <v-text-field v-if="pageType == 'Canvas'" label="Image URL or Link" dense outlined v-model="item.image"></v-text-field>
                            <v-img v-if="item.image != null" contain :height="styles.image.height" :width="styles.image.width" :src="item.image" class="mx-auto"></v-img>
                        </div>
                    </v-col>
                </template>
            </v-row>
        </v-card>
    </div>
</template>

<script>
import { mapState } from "vuex"
export default {
    props: ["item", "styles", "indexes"],
    data () {
        return {
            cardHeight: ""
        }
    },
    computed: {
        ...mapState("units", ["layout"]),
        pageType () {
            return this.$route.name
        },
        isLayoutGME () {
            return this.layout == "GME" ? "gme-image-upload" : ""
        },
        containImage () {
            return ["FSIC1"].includes(this.layout) ? true : this.$vuetify.breakpoint.mdAndUp
        }
    },

    mounted () {
        this.$nextTick(function () {
            if (this.layout == "FTQA") {
                this.addBorderFTQA()
            }

            const layoutsForEqualHeight = ["CJB2", "CJBA", "GME", "HD1", "BEDA", "PH3"]
            if (layoutsForEqualHeight.includes(this.layout) && this.$vuetify.breakpoint.lgAndUp) {
                let largestHeight = 0
                const cards = document.querySelectorAll("#cardsForHeight")
                // set timeout to wait for DOM to load/render to get proper height before setting card height
                setTimeout(() => {
                    cards.forEach(card => largestHeight = largestHeight < card.offsetHeight ? card.offsetHeight : largestHeight)
                    this.cardHeight = largestHeight
                }, 1500)
            }
        })
    },
    methods: {
        onEditableChange (type) {
            this.columnEditableData("imagecard2", this.indexes, type)
        },
        adjustedClass () {
            //
        },
        uploadImage () {
            this.$emit("uploadImage", true)
        },

        addBorderFTQA () {
            const cardContainer = document.querySelectorAll("#cardContainer")
            for (var i = 0; i < cardContainer.length; i++) {
                var question = cardContainer[i].parentElement.nextSibling.innerText
                if (navigator.userAgent.indexOf("Safari") > -1 && navigator.userAgent.indexOf("Chrome") == -1) {
                    question = question != undefined ? question.trim() : ""
                }
                if (question == "Questions") {
                    cardContainer[i].firstChild.classList.add("ftqa-img-card")
                    cardContainer[i].firstChild.classList.remove("ftqa-img-card2")
                }
                else {
                    cardContainer[i].firstChild.classList.add("ftqa-img-card2")
                    cardContainer[i].firstChild.classList.remove("ftqa-img-card")
                }
            }
        },

        imageLeftColClass () {
            let customClass

            if (this.layout == "PPJI") {
                customClass = this.item.text.length == 0 ? "d-flex justify-center mx-auto" : ""
            }

            if (this.layout == "CJB2") {
                customClass = "d-flex justify-center"
            }

            return customClass
        }
    }
}
</script>

<style scoped>
.speaking-pattern {
    background: linear-gradient(to right top, #00ff87, #60efff);
}
.travel-english {
    background: #F4F5F7 !important;
}
.dark-blue {
  color: #131e56;
}
.hd1-word-highlight {
  background-color: #ffd7cf;
  font-weight: bold;
  text-align: center;
  width: 90%;
  margin: 0 auto;
}

.ie-card {
    background: #FFD7BA !important;
    height: 100% !important;
}

.gme-title {
  background: #129490;
  margin-top: -50px !important;
  position: relative;
  left: 50%;
  transform: translate(-50%, 0);
  max-width: 250px;
}

.gme-subtitle {
    font-weight: bold;
    text-align: center;
    margin: 0 auto;
    max-width: 280px;
}

.ph1-gradient-card {
  background: linear-gradient(to right, #73bcff, #99e2e0);
  padding: 1rem;
}
.ph2-gradient-card {
    background: linear-gradient(to right, #f35167, #ffedc0);
    padding: 1rem;
}

.ph3-gradient-card {
  background: linear-gradient(to right, #f561ae, #ffb6d6);
  padding: 1rem;
}

.ph3-floating-card {
  /* width: max-content; */
  box-shadow: 0px 5px 15px 0px rgba(245, 97, 174, 0.75) !important;
  -webkit-box-shadow: 0px 5px 15px 0px rgba(245, 97, 174, 0.75);
  -moz-box-shadow: 0px 5px 15px 0px rgba(245, 97, 174, 0.75);
}

.ph4-outlined-card {
  border: 3px solid #8dd3f7 !important;
  padding: 1rem;
}

.ph4-bordered-card {
  border-left: 5px solid #1faefb !important;
  display: block;
}

.ph5-outlined-card {
  border: 1px solid #f6edd9 !important;
}

.ph5-colored-card {
    background-color: #F6EDD9 !important;
}

.ph6-gradient-card {
  background: linear-gradient(to right, #f9af87, #fccc69);
}

.ph6-bordered-card {
  border-left: 5px solid #1faefb !important;
}

 .milestone-border{
        border-radius: 20px !important;
        border: 3px solid #169bd6 !important;
    }
.beda {
    min-height: 400px !important;
}

.besd {
    background: linear-gradient(to right top, #80ffdb, #ffffff);
}

.cja-img-card {
    background-color: #8CD1D1;
}

.cjb-img-card {
    background-color: #CBD2F5;
    font-size: min(4vw, 1.2em)
}
.cji-img-card {
    background-color: #F1DACD;
    font-size: min(4.5vw, 1.2em);
}

.ftqa-img-card {
    border:  3px solid #dfe7fd;
    border-radius: 0px;
    border-width: 3px 3px 0px 3px;
}

.ftqa-img-card2 {
    border:  3px solid #dfe7fd;
    border-width: 3px 3px 3px 3px;
    margin-bottom: 40px;
}

</style>
